import { ReactNode } from 'react';

import { Text } from '../../atoms/text/text';

type SubRowTableColumn<T> = {
  readonly header: string;
  readonly render: (row: T) => ReactNode;
};

type SubRowTableProps<T extends { id: string }> = {
  readonly columns: SubRowTableColumn<T>[];
  readonly rows: T[];
  readonly emptyMessage: string;
};

const SubRowTable = <T extends { id: string }>({ columns, rows, emptyMessage }: SubRowTableProps<T>) => {
  if (!rows.length) {
    return <Text className="p-4">{emptyMessage}</Text>;
  }

  return (
    <table className="w-auto">
      <thead>
        <tr>
          <th className="w-20"></th>
          {columns.map(({ header }) => (
            <th className="text-left font-normal text-typography-light pb-2 pr-6 last:pr-0" key={header}>
              {header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row) => (
          <tr key={row.id}>
            <td></td>
            {columns.map(({ header, render }) => (
              <td className="py-1 pr-6 last:pr-0" key={header}>
                {render(row)}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export { SubRowTable };
export type { SubRowTableColumn };
